export enum TransactionDirection {
  Incoming = 'Incoming',
  Outgoing = 'Outgoing',
}
